import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Form } from '../models';
import { FormActions, FormActionTypes } from '../actions';

export interface FormState extends EntityState<Form> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<Form> = createEntityAdapter<Form>({
  selectId: (form) => form.id,
});

export const initialFormState: FormState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function formReducer(state = initialFormState, action: FormActions): FormState {
  switch (action.type) {
    case FormActionTypes.ToggleFormPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case FormActionTypes.ToggleFormActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case FormActionTypes.LoadFormPage:
      return adapter.addMany(action.payload.forms, {
        ...initialFormState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case FormActionTypes.CancelFormPage:
      return { ...state, query: new QueryParamsModel({}) };

    case FormActionTypes.CreateForm:
      return adapter.addOne(action.payload.form, state);

    case FormActionTypes.UpdateForm:
      return adapter.updateOne(action.payload.form, state);

    case FormActionTypes.ThrowFormError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case FormActionTypes.ClearFormError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
